import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import './AdminPage.css';
import { usePlans } from '../utils/usePlans';
import { useCompanies } from '../hooks/useCompanies';
import { logout } from '../api/auth';
import { downloadAllCsv } from '../api/payment';
import { NoticeModal } from '../components/Modals';

const AdminPage = () => {
  const { oneTimeOptions, subscriptionOptions, loading } = usePlans();
  const { companies, error, isLoading } = useCompanies();
  const [noticeOpen, setNoticeOpen] = useState(false);
  const [noticeMsg, setNoticeMsg] = useState('');

  const navigate = useNavigate();

  const planLabelMap = {};
  [...oneTimeOptions, ...subscriptionOptions].forEach((option) => {
    if (option.price_id) {
      planLabelMap[option.price_id] = option.name;
    }
  });

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('ログアウト失敗:', error);
    } finally {
      localStorage.clear();
      navigate('/login');
    }
  };

  const handleCompanyDashboard = (companyId) => {
    localStorage.setItem('companyId', companyId);
    navigate(`/dashboard/${companyId}`);
  };

  const showNotice = (msg) => {
    setNoticeMsg(msg);
    setNoticeOpen(true);
  };

  const downloadCompaniesCSV = async () => {
    if (!companies || companies.length === 0) {
      showNotice('ダウンロード可能なデータがありません');
      return;
    }

    try {
      const blob = await downloadAllCsv();
      const url = URL.createObjectURL(blob);

      const dateStr = new Date().toISOString().slice(0, 10).replace(/-/g, '');
      const fileName = `全企業会員情報${dateStr}.csv`;

      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.click();

      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('CSVダウンロードエラー:', error);
      alert('CSVダウンロードに失敗しました');
    }
  };

  if (loading || isLoading) return <div>データを読み込み中...</div>;

  return (
    <div className="adminBody">
      <h2 className="adminPageTitle">企業一覧</h2>

      {error && (
        <p className="error">企業データの取得に失敗しました: {error.message}</p>
      )}

      {companies && companies.length === 0 ? (
        <p>企業データがありません</p>
      ) : companies && companies.length > 0 ? (
        <div className="companyList">
          {companies.map((company) => (
            <div key={company.id} className="adminList">
              <h3>{company.company_name}</h3>
              <div className="adminElement">
                <button
                  onClick={() => handleCompanyDashboard(company.id)}
                  className="adminButton"
                >
                  QRコード一覧
                </button>

                <button
                  onClick={() =>
                    navigate(`/adminpage/${company.id}`, {
                      state: { companyName: company.company_name },
                    })
                  }
                  className="adminButton"
                >
                  支払い情報を表示
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : null}

      <div className="A_pageBackButton">
        <button
          onClick={downloadCompaniesCSV}
          className="adminCsvButton"
        >
          全企業のCSV ダウンロード
        </button>
      </div>
      <NoticeModal
        open={noticeOpen}
        message={noticeMsg}
        onClose={() => setNoticeOpen(false)}
      />
    </div>
  );
};

export default AdminPage;
